// extracted by mini-css-extract-plugin
export default {"Log":"Log_Log__4b3YD"};